const yup = require("yup");

const rewards = yup.object().shape({
  fundingAccount: yup.string().required("Select a funding account"),
  amount: yup
    .number()
    .positive("Amount must be positive")
    .test("is-decimal", "Amount can have at most 2 decimal places", (value) =>
      value ? /^\d+(\.\d{1,2})?$/.test(value) : true,
    )
    .test(
      "is-not-greater-than-earned",
      "Amount cannot be greater than available rewards",
      function (value) {
        const { earnedRewards } = this.parent;
        return value <= parseFloat(earnedRewards);
      },
    )
    .required("Amount is required"),
  earnedRewards: yup.number(),
  confirmTransfer: yup.boolean(),
  memo: yup.string(),
});

export default rewards;
